import { SearchScope } from 'owa-search-service';
import { action } from 'satcheljs';

const setStaticSearchScope = action('setStaticSearchScope', (searchScope: SearchScope) => ({
    searchScope,
}));

export default setStaticSearchScope;
